import styled from 'styled-components/macro';

const Separator = styled.hr`
  border: 1px solid #ebecf2;
  margin: ${({ theme }) => theme.spacing.spacingSizes.lg} 0;
  width: 100%;
`;

export default Separator;
